import React, { FC } from 'react';
import { TextField } from '@atoms';
import { SelectFabric } from '@molecules';

export interface FormData {
  fullName?: string;
  role?: 'admin' | 'user';
  email?: string;
}

const CreateNewEnterpriseUsersModalForm: FC<{ control: any }> = ({ control }) => (
  <>
    <TextField
      name="fullName"
      label="Full name"
      placeholder="Enter your full name"
      control={control}
      sx={{ mb: '24px' }}
    />
    <SelectFabric
      name="role"
      label="User Role"
      placeholder="Select role"
      control={control}
      options={[{ label: 'Admin', value: 'admin' }]}
      sx={{ mb: '24px' }}
    />
    <TextField
      name="email"
      label="User Email"
      placeholder="name@ceartas.io"
      control={control}
      required
      sx={{ mb: '24px' }}
    />
  </>
);

export default CreateNewEnterpriseUsersModalForm;
